import BaseComponent from "@js/components/base_component.jsx";

class EuiSearchBar extends BaseComponent {

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-offset-0 col-sm-8">
                        {this.props.q && <span>
                            {
                                I18n.t("phrases.showing_search_results_for_q", {
                                    q: this.props.q
                                })
                            }
                            {
                                this.props.clarification && (
                                    <React.Fragment>
                                        <br/>
                                        { this.props.clarification }
                                    </React.Fragment>
                                )
                            }
                        </span>}
                    </div>
                    <div className="col-sm-4">
                        <EuiSearchBox
                            defaultValue={ this.props.q }
                            target={ (q) => this.props.route(q) }
                            placeholder={ this.props.placeholder }
                        />
                    </div>
                </div>
                <br />
            </React.Fragment>
        );
    }

}

export default EuiSearchBar;
